import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { useMemo } from 'react';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { Admin } from '#dn-types/admin.ts';
import { AdminsActionMenu } from './AdminsActionMenu.tsx';

type Props = {
  data: Admin[];
  isFetching: boolean;
  currentUserEmail: string;
  className?: string;
};

const columnHelper = createColumnHelper<Admin>();

export function AdminsList({ data, isFetching, currentUserEmail, className }: Props) {
  const columns = useMemo(
    () => [
      columnHelper.accessor('email', {
        header: 'Email',
        size: 300,
        meta: {
          truncate: true,
        },
      }),
      columnHelper.accessor('createdAt', {
        header: 'Added',
        size: 240,
        cell(info) {
          return <Timestamp datetime={info.getValue()} />;
        },
        meta: {
          truncate: true,
        },
      }),
      columnHelper.display({
        id: 'action-menu',
        header: '',
        size: 34,
        cell(info) {
          const admin = info.row.original;
          return (
            <div className="flex justify-end">
              <AdminsActionMenu admin={admin} currentUserEmail={currentUserEmail} />
            </div>
          );
        },
      }),
    ],
    [currentUserEmail]
  );

  return <Table className={cn({ 'opacity-dim': isFetching }, className)} data={data} columns={columns} />;
}
